import { createRoot } from 'react-dom/client'
import './styles.css'
import App from './App'
import React  from 'react';

createRoot(document.getElementById('root')).render(<App />)
